import React from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import { authRoutes, publicRoutes } from './routes';

export default function Router() {
  return useRoutes([
    ...publicRoutes,
    ...authRoutes,
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
